import React, { useEffect, useRef } from 'react';
export function Hero() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const mousePos = useRef({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const particles: Array<{
      x: number;
      y: number;
      vx: number;
      vy: number;
      size: number;
    }> = [];
    // Create particles
    for (let i = 0; i < 100; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.5,
        vy: (Math.random() - 0.5) * 0.5,
        size: Math.random() * 2 + 1
      });
    }
    const handleMouseMove = (e: MouseEvent) => {
      mousePos.current = {
        x: e.clientX,
        y: e.clientY
      };
    };
    window.addEventListener('mousemove', handleMouseMove);
    const animate = () => {
      ctx.fillStyle = 'rgba(17, 24, 39, 0.1)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      particles.forEach(particle => {
        // Mouse interaction
        const dx = mousePos.current.x - particle.x;
        const dy = mousePos.current.y - particle.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (distance < 150) {
          particle.vx += dx * 0.00005;
          particle.vy += dy * 0.00005;
        }
        particle.x += particle.vx;
        particle.y += particle.vy;
        // Boundary check
        if (particle.x < 0 || particle.x > canvas.width) particle.vx *= -1;
        if (particle.y < 0 || particle.y > canvas.height) particle.vy *= -1;
        // Draw particle
        ctx.fillStyle = 'rgba(147, 51, 234, 0.6)';
        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        ctx.fill();
        // Draw connections
        particles.forEach(otherParticle => {
          const dx = particle.x - otherParticle.x;
          const dy = particle.y - otherParticle.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          if (distance < 100) {
            ctx.strokeStyle = `rgba(147, 51, 234, ${0.2 - distance / 500})`;
            ctx.lineWidth = 0.5;
            ctx.beginPath();
            ctx.moveTo(particle.x, particle.y);
            ctx.lineTo(otherParticle.x, otherParticle.y);
            ctx.stroke();
          }
        });
      });
      requestAnimationFrame(animate);
    };
    animate();
    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return <section className="relative h-screen flex items-center justify-center overflow-hidden bg-gray-900 dark:bg-gray-950" data-id="element-117">
      <canvas ref={canvasRef} className="absolute inset-0 w-full h-full" data-id="element-118" />

      <div className="relative z-10 text-center px-4" data-id="element-119">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uo4iwWVSECmyeiyJjvjjvp/K_V4-2.png" alt="KONTAXES" className="mx-auto h-32 w-auto mb-8 animate-pulse" data-id="element-120" />
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 animate-fade-in" data-id="element-121">
          de números a decisiones
        </h1>
        <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto" data-id="element-122">
          Contabilidad, Impuestos, Asesoría Financiera y Consultoría
        </p>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce" data-id="element-123">
        <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2" data-id="element-124">
          <div className="w-1 h-3 bg-white rounded-full" data-id="element-125"></div>
        </div>
      </div>
    </section>;
}